module.exports = __webpack_public_path__ + "img/new-logo.66e8ba53.png";